import { motion } from 'framer-motion';
import { FileText, Phone, CheckCircle, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import PageHeader from '@/components/common/PageHeader';
import ConsultationForm from '@/components/common/ConsultationForm';
import { usePageMeta, useServiceSchema } from '@/hooks/useSEO';

const ResumeWritingPage = () => {
  usePageMeta(
    'Professional Resume Writing Services for Overseas Jobs 2026 | ATS-Optimized — Zafco HR',
    'ATS-optimized resume writing by Zafco HR for Gulf, Canada, Australia & UK applications. Recruiter-vetted CVs, LinkedIn optimisation, cover letters. Trusted by 10,000+ placed candidates.'
  );
  useServiceSchema({
    name: 'Professional Resume Writing & ATS Optimisation',
    description:
      'ATS-optimised resume writing, LinkedIn profile makeover, and cover-letter crafting for overseas job applications across Gulf, Canada, Australia, UK and Germany.',
    serviceType: 'Career Counseling',
    areaServed: ['India'],
    url: 'https://zafco.in/resume-writing-services',
  });
  const openWhatsApp = () => {
    window.open('https://wa.me/919958848998?text=Hello%20Zafco,%20I%20need%20resume%20writing%20services', '_blank');
  };

  return (
    <div data-testid="resume-writing-page">
      <PageHeader 
        title="Professional Resume Writing Services"
        subtitle="Get ATS-optimized resumes that land interviews in Canada, Australia, and beyond"
        breadcrumbs={[{ label: 'Services' }, { label: 'Resume Writing' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold text-zafco-blue font-montserrat mb-6">
                Stand Out in the Global Job Market
              </h2>
              <p className="text-gray-600 mb-6">
                Your resume is your first impression on international employers. Our professional resume 
                writers create compelling, ATS-friendly resumes tailored to your target country's standards.
              </p>

              <div className="space-y-4 mb-8">
                {[
                  'ATS-optimized format for higher visibility',
                  'Country-specific resume standards',
                  'Keyword optimization for your industry',
                  'LinkedIn profile optimization included',
                  'Cover letter writing',
                  'Unlimited revisions',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>

              <Button 
                onClick={openWhatsApp}
                className="bg-gradient-to-r from-zafco-gold to-zafco-orange text-white"
              >
                <Phone className="w-5 h-5 mr-2" />
                Get Started - ₹2,999
              </Button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-8 shadow-xl"
            >
              <h3 className="text-xl font-bold text-zafco-blue font-montserrat mb-6">
                Request Resume Service
              </h3>
              <ConsultationForm />
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResumeWritingPage;
